import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Form
} from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import history from '#/history';
import { resolveValidation } from '#/meta';
import rgx from '#/regex';

import { actions } from './sagaSlice';

const validators = {
    password: val => !!val && resolveValidation(val, rgx['password']),
    confirm: (a, b) => a === b
};

const semanticErrors = {
    password: {
        content: 'Enter valid password',
        pointing: 'below'
    },
    confirm: {
        content: 'Password must match',
        pointing: 'below'
    }
};

const checkErrors = payload => {

    const validations = {
        password: !validators.password(payload.password),
        confirm: !validators.confirm(payload.password, payload.confirm)
    };

    return validations;
};

export default connect(state => state.auth, actions)(props => {

    if (props.isSignedIn) {

        history.push('/');
    }

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [errors, setErrors] = useState('');
    const { token } = useParams();

    const isValid = payload => {

        const err = checkErrors(payload);
        setErrors(err);

        return !Object.values(err).includes(true);
    };

    const onSubmit = e => {

        e.preventDefault();

        // eslint-disable-next-line object-property-newline
        if (isValid({ password, confirm })) {

            props.resetPassword({
                password,
                reset_token: token
            });

            history.push('/login');
        }

    };

    return (
        <Form onSubmit={ onSubmit } loading={ props.isFetching }>

            <h1>Set your new password</h1>

            <Form.Field>

                <Form.Input required
                    fluid
                    name='password'
                    type='password'
                    placeholder='Password'
                    label='Password'
                    onChange={e => setPassword(e.target.value)}
                    error={ errors.password ? semanticErrors.password : false}
                />
            </Form.Field>
            <Form.Field>

                <Form.Input required
                    fluid
                    name='confirm'
                    type='password'
                    placeholder='Confirm Password'
                    label='Confirm Password'
                    onChange={e => setConfirm(e.target.value)}
                    error={ errors.confirm ? semanticErrors.confirm : false}
                />
            </Form.Field>
            <Form.Field>
                <Button type='submit'>Reset Password</Button>
            </Form.Field>
        </Form>
    );
});
